import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import { formatToDate } from "../master/FormatToDateTime";
import "./HostelStudentIdCardModern.css";

const getProfilePicture = (data) =>
  data?.profile_picture || data?.student?.profile_picture || null;

// A third hostel ID card design: a clean, off-white "badge" style with a
// color accent band and a monospaced ID strip along the bottom. Same data
// shape as the other two designs, so it's a drop-in swap.
export default function HostelStudentIdCardModern({ data }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    try {
      const raw = localStorage.getItem("setting");
      setSetting(raw ? JSON.parse(raw) : {});
    } catch (e) {
      setSetting({});
    }
  }, []);

  const profilePicture = getProfilePicture(data);

  return (
    <div className="hostel-id-card-modern-1 id-card-print-block">
      <div className="m1-band">
        {setting?.logo_img && (
          <img
            className="m1-logo"
            src={imgBaseUrl + setting.logo_img}
            alt="Institute logo"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        )}
        <div className="m1-band-text">
          <p className="m1-institute-name">{setting?.name}</p>
          <p className="m1-institute-sub">
            {[setting?.village, setting?.district, setting?.state]
              .filter(Boolean)
              .join(", ")}
          </p>
        </div>
      </div>

      <div className="m1-body">
        <div className="m1-photo">
          <img
            src={
              profilePicture ? imgBaseUrl + profilePicture : "/files/user.png"
            }
            alt={data?.student_name ?? "Student"}
            onError={(e) => {
              e.currentTarget.src = "/files/user.png";
            }}
          />
        </div>

        <div className="m1-info">
          <span className="m1-tag">Hostel Card</span>
          <p className="m1-name">{data?.student_name}</p>
          <div className="m1-grid">
            <span className="m1-label">Father</span>
            <span className="m1-value">{data?.father_name}</span>
            <span className="m1-label">Mobile</span>
            <span className="m1-value">{data?.mobile}</span>
            <span className="m1-label">Hostel</span>
            <span className="m1-value">{data?.hostel?.name}</span>
            <span className="m1-label">Room</span>
            <span className="m1-value">{data?.room?.room_no}</span>
          </div>
        </div>
      </div>

      {data?.address && <div className="m1-address">{data.address}</div>}

      <div className="m1-strip">
        <span className="m1-id">{data?.registration_no}</span>
        <span className="m1-joined">
          Joined {formatToDate(data?.joining_date)}
        </span>
        {setting?.signature && (
          <img
            className="m1-sign"
            src={imgBaseUrl + setting.signature}
            alt="Authorized signature"
          />
        )}
      </div>
    </div>
  );
}
